import React from "react";
import { ymdTodayLocal } from "../utils/dateUtils";
import { AppleDateInput } from "./AppleDateInput";
import { A } from "../styles/appleClasses";

function clampRange(nextStart: string, nextEnd: string) {
  if (nextStart && nextEnd && nextStart > nextEnd) {
    return { startDate: nextStart, endDate: nextStart };
  }
  return { startDate: nextStart, endDate: nextEnd };
}

export type DateRangeFilterProps = {
  variant?: "range" | "asOf";

  startDate: string;
  endDate: string;
  onChange: (range: { startDate: string; endDate: string }) => void;

  minDate?: string;
  maxDate?: string;

  fromLabel?: string;
  toLabel?: string;
  asOfLabel?: string;
  openCalendarLabel?: string;

  className?: string;
};

export function DateRangeFilter({
  variant = "range",
  startDate,
  endDate,
  onChange,
  minDate,
  maxDate,
  fromLabel = "From",
  toLabel = "To",
  asOfLabel = "As at",
  openCalendarLabel,
  className = "",
}: DateRangeFilterProps) {
  const hardMax = maxDate ?? ymdTodayLocal();
  const labelCls = `block mb-1 ${A.label}`;

  if (variant === "asOf") {
    const asOf = endDate;

    return (
      <div className={className}>
        <label className={labelCls}>{asOfLabel}</label>

        <AppleDateInput
          openCalendarLabel={openCalendarLabel}
          valueYmd={asOf}
          onChangeYmd={(v) => onChange({ startDate: v, endDate: v })}
          minYmd={minDate}
          maxYmd={hardMax}
          allowEmpty
          ariaLabel={asOfLabel}
          className="w-full"
        />
      </div>
    );
  }

  return (
    <div className={`flex gap-4 items-end ${className}`}>
      <div className="min-w-0">
        <label className={labelCls}>{fromLabel}</label>
        <AppleDateInput
          openCalendarLabel={openCalendarLabel}
          valueYmd={startDate}
          onChangeYmd={(v) => onChange(clampRange(v, endDate))}
          minYmd={minDate}
          maxYmd={endDate || hardMax}
          allowEmpty
          ariaLabel={fromLabel}
          className="w-full"
        />
      </div>

      <div className="min-w-0">
        <label className={labelCls}>{toLabel}</label>
        <AppleDateInput
          openCalendarLabel={openCalendarLabel}
          valueYmd={endDate}
          onChangeYmd={(v) => onChange(clampRange(startDate, v))}
          minYmd={startDate || minDate}
          maxYmd={hardMax}
          allowEmpty
          ariaLabel={toLabel}
          className="w-full"
        />
      </div>
    </div>
  );
}
